<button mat-raised-button color="primary" type="button" (click)="onClick()">
  {{ label | uppercase }}

  <span *ngIf="nbFilters > 0" class="filters-bubble">
    {{ nbFilters }}
  </span>
</button>
